import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { Breadcrumb, Row, Col, Button, Checkbox, Skeleton } from 'antd';
import { permissionService } from 'shared/services';
import { userPermissions } from 'shared/constant';

import Table from 'components/Table';
import organizationRoute from '../../route';

import text from './EmployeeRoleDetail.page.translation';

import './EmployeeRoleDetail.style.less';

export class EmployeeRoleDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employeePermission: [],
      subModuleCheckBox: [],
      companyRole: [],
      roleId: this.props.match.params.id || '',
    };
  }

  componentDidMount() {
    if (this.state.roleId) {
      this.props.getSingleEmployeeRole(this.state.roleId, this._cduSetState);
    }
  }

  _cduSetState = roleDetail => {
    const getRoleDetail = _.get(roleDetail, 'payload', {});
    const setFormatEmployeePermission = [
      {
        id: '1',
        section: 'Login',
        permission_name: 'Dashboard',
        permission: _.get(getRoleDetail, 'login_dashboard', false),
        value: 'dashboard',
      },
      {
        id: '2',
        section: 'Login',
        permission_name: 'App',
        permission: _.get(getRoleDetail, 'login_app', false),
        value: 'app',
      },
    ];

    const getCompanyRole = [];
    const setFormatSubModuleCheckBox = [];

    const dataModule = _.get(getRoleDetail, 'module', '');
    if (dataModule) {
      const checkModules = [dataModule];
      checkModules.forEach(x => {
        getCompanyRole.push(x.identifier);

        if (x.scopes) {
          const getCheckBoxProcess = this._setSubModuleProcess(x);
          setFormatSubModuleCheckBox.push(...getCheckBoxProcess);
        }
      });
    }

    this.setState({
      employeePermission: setFormatEmployeePermission,
      subModuleCheckBox: setFormatSubModuleCheckBox,
      companyRole: getCompanyRole,
    });
  };

  _setSubModuleProcess = module => {
    const getPermission = [];
    const resultProcess = [];
    module.scopes.forEach(data => {
      const splitData = data.split(':');
      const getIndex = _.findIndex(getPermission, [
        'subModuleName',
        splitData[0],
      ]);
      if (getIndex > -1) {
        getPermission[getIndex].permission.push(splitData[1]);
      } else {
        getPermission.push({
          subModuleName: splitData[0],
          permission: [splitData[1]],
        });
      }
    });

    getPermission.forEach((data, idx, index) => {
      let startFlag = false;
      if (idx === 0) {
        startFlag = true;
      }

      resultProcess.push({
        id: module.id + idx,
        moduleName: module.identifier,
        subModuleName: data.subModuleName,
        identifier: module.identifier,
        permission: data.permission,
        size: index.length,
        startFlag,
      });
    });
    return resultProcess;
  };

  _renderInfoRole = () => {
    const {
      intl: { formatMessage },
      loading,
      employeeRoleDetail,
    } = this.props;
    const { companyRole } = this.state;
    const getEmployeeRoleName = _.get(employeeRoleDetail, 'payload.name', '');
    const getEmployeeRoleDescription = _.get(
      employeeRoleDetail,
      'payload.description',
      '',
    );
    return (
      <div className="inner-wrapper">
        <Skeleton
          loading={loading}
          active
          paragraph={{ rows: 1, width: ['100%'] }}
          title={false}
        >
          <div className="one-row">
            <span className="label">{formatMessage(text.labelRoleName)}</span>
            <span className="value transformInitial">
              {getEmployeeRoleName}
            </span>
          </div>
        </Skeleton>

        <Skeleton
          loading={loading}
          active
          paragraph={{ rows: 1, width: ['100%'] }}
          title={false}
        >
          <div className="one-row">
            <span className="label">
              {formatMessage(text.labelRoleDescription)}
            </span>
            <span className="value transformInitial">
              {getEmployeeRoleDescription}
            </span>
          </div>
        </Skeleton>

        <Skeleton
          loading={loading}
          active
          paragraph={{ rows: 1, width: ['100%'] }}
          title={false}
        >
          <div className="one-row">
            <span className="label">
              {formatMessage(text.labelCompanyRole)}
            </span>
            <span className="value">{companyRole.toString()}</span>
          </div>
        </Skeleton>
      </div>
    );
  };

  _renderEditbtn = () => {
    const {
      employeeRoleDetail,
      intl: { formatMessage },
    } = this.props;
    const getEmployeeRoleId = _.get(employeeRoleDetail, 'payload.role_id', '');
    return (
      <Button
        type="primary"
        block
        className="btn edit-btn"
        onClick={() => {
          this.props.history.push(
            organizationRoute.EMPLOYEE_ROLE_EDIT.replace(
              ':id',
              getEmployeeRoleId,
            ),
          );
        }}
      >
        {formatMessage(text.btnEdit)}
      </Button>
    );
  };

  _renderBackbtn = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Link to={organizationRoute.EMPLOYEE_ROLE_LIST}>
        <Button type="default" block className="btn back-btn">
          {formatMessage(text.btnBack)}
        </Button>
      </Link>
    );
  };

  _getRowId = row => row.id;

  _renderEmployeePermissionTable = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    const tableColumn = [
      {
        title: formatMessage(text.labelSection),
        key: 'index',
        width: '40%',
        align: 'left',
        dataIndex: 'section',
        render: this._renderLabelSection,
      },
      {
        title: formatMessage(text.labelPermission),
        dataIndex: 'permission_name',
        width: '40%',
        align: 'left',
      },
      {
        title: formatMessage(text.labelAction),
        key: '',
        width: '20%',
        align: 'center',
        render: this._renderLabelAction,
      },
    ];

    return tableColumn;
  };

  _renderLabelSection = (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    if (index === 0) obj.props.rowSpan = 2;
    if (index === 1) obj.props.rowSpan = 0;
    return obj;
  };

  _renderLabelAction = value => (
    <Checkbox defaultChecked={value.permission} disabled />
  );

  _renderSubModuleRoles = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    const tableColumn = [
      {
        title: formatMessage(text.labelModule),
        width: '25%',
        key: 'id',
        align: 'left',
        dataIndex: 'moduleName',
        render: this._renderModulName,
      },
      {
        title: formatMessage(text.labelSubModule),
        width: '25%',
        align: 'left',
        dataIndex: 'subModuleName',
      },
      {
        title: formatMessage(text.labelPermission),
        className: 'bbottom',
        children: [
          this._childrenColumn('create'),
          this._childrenColumn('read'),
          this._childrenColumn('update'),
          this._childrenColumn('delete'),
        ],
      },
    ];

    return tableColumn;
  };

  _renderModulName = (value, row) => {
    const obj = {
      children: value,
      props: {},
    };

    if (row.startFlag) {
      obj.props.rowSpan = row.size;
    } else {
      obj.props.rowSpan = 0;
    }

    return obj;
  };

  _childrenColumn = key => {
    const {
      intl: { formatMessage },
    } = this.props;
    const getLabel = `label${_.capitalize(key)}`;
    return {
      title: formatMessage(text[getLabel]),
      width: '12.5%',
      key,
      align: 'center',
      render: this._renderChildrenColumn(key),
    };
  };

  _renderChildrenColumn = key => value => {
    let statusChecked = false;
    if (value.permission && value.permission.includes(key)) {
      statusChecked = true;
    }
    return <Checkbox defaultChecked={statusChecked} disabled></Checkbox>;
  };

  render() {
    const {
      intl: { formatMessage },
      loading,
    } = this.props;

    const canUpdateRole =
      permissionService.checkPermission(userPermissions.UPDATE_ROLE, true) &&
      permissionService.checkPermission(userPermissions.READ_ROLE, true) &&
      !loading;

    return (
      <div className="main-content">
        <div className="breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={organizationRoute.EMPLOYEE_ROLE_LIST}>
                {formatMessage(text.breadcrumbRoleList)}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {formatMessage(text.breadcrumbRoleDetail)}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="white-box-wrapper employee-role-detail">
          <span className="big-title">
            {formatMessage(text.employeeRoleDetailTitle)}
          </span>

          <div className="info-role-wrapper">{this._renderInfoRole()}</div>

          <Row gutter={24} className="mbottom30">
            <Col span={14}>
              <label className="label-style">
                {formatMessage(text.labelEmployeePermission)}
              </label>
              <Table
                rowID={this._getRowId}
                columns={this._renderEmployeePermissionTable()}
                dataSource={this.state.employeePermission}
                rowClass="striped-table"
                pagination=""
                loadingValue={loading}
              />
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={24}>
              <Table
                rowID={this._getRowId}
                columns={this._renderSubModuleRoles()}
                dataSource={this.state.subModuleCheckBox}
                rowClass="striped-table"
                pagination=""
                loadingValue={loading}
              />
            </Col>
          </Row>

          {!loading && this._renderBackbtn()}
          {canUpdateRole && this._renderEditbtn()}
        </div>
      </div>
    );
  }
}

EmployeeRoleDetail.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  getSingleEmployeeRole: PropTypes.func.isRequired,
  employeeRoleDetail: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  match: PropTypes.object,
};

export default EmployeeRoleDetail;
